import React from 'react'
import Footer from '../Footer'
import EducationCLRHS6 from '../EducationCLRHS6'

function CLRHS6() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS6/>
            <Footer/>
        </div>
    )
}

export default CLRHS6
